import { HttpMethod, initFetch } from "../../utils/fetcher";
import { DELETE_SUCCESS_RENDUA_PC } from "./renduAction";
import {
  adaptedToParcoursClient,
  parcoursClientsToAdapted,
  parcoursClientToAdapted,
} from "../../adapter/parcoursClientAdapter";

export const LOAD_SUCCESS_PARCOURS_CLIENTS = "LOAD_SUCCESS_PARCOURS_CLIENTS";
export const LOAD_FAIL_PARCOURS_CLIENTS = "LOAD_FAIL_PARCOURS_CLIENTS";
export const SAVE_SUCCESS_PARCOURS_CLIENTS = "SAVE_SUCCESS_PARCOURS_CLIENTS";
export const SAVE_FAIL_PARCOURS_CLIENTS = "SAVE_FAIL_PARCOURS_CLIENTS";
export const UPDATE_SUCCESS_PARCOURS_CLIENTS = "UPDATE_SUCCESS_PARCOURS_CLIENTS";
export const UPDATE_FAIL_PARCOURS_CLIENTS = "UPDATE_FAIL_PARCOURS_CLIENTS";
export const DELETE_SUCCESS_PARCOURS_CLIENTS = "DELETE_SUCCESS_PARCOURS_CLIENTS";
export const DELETE_FAIL_PARCOURS_CLIENTS = "DELETE_FAIL_PARCOURS_CLIENTS";

export function loadParcoursClients() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`parcoursClients`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.parcours_client);
          dispatch({
            type: LOAD_SUCCESS_PARCOURS_CLIENTS,
            payload: parcoursClientsToAdapted(res.parcours_client),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_PARCOURS_CLIENTS,
            error: err,
          });
        });
    });
  };
}

export function saveParcoursClient(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`parcoursClients`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToParcoursClient(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.parcours_client);
          dispatch({
            type: SAVE_SUCCESS_PARCOURS_CLIENTS,
            payload: parcoursClientToAdapted(res.parcours_client),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_PARCOURS_CLIENTS,
            error: err,
          })
        );
    });
  };
}

export function updateParcoursClient(jsonData, idG, idE) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`parcoursClients/${idE}/${idG}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToParcoursClient(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.parcours_client);
          dispatch({
            type: UPDATE_SUCCESS_PARCOURS_CLIENTS,
            payload: parcoursClientToAdapted(res.parcours_client),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_PARCOURS_CLIENTS,
            error: err,
          })
        );
    });
  };
}

export function deleteParcoursClient(idG, idE) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`parcoursClients/${idE}/${idG}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => res.json())
        .then((res) => {
          resolve(res.parcours_client);
          dispatch({
            type: DELETE_SUCCESS_PARCOURS_CLIENTS,
            payload: parcoursClientToAdapted(res.parcours_client),
            idG: idG,
            idE: idE,
          });
          dispatch({
            type: DELETE_SUCCESS_RENDUA_PC,
            payload: parcoursClientToAdapted(res.parcours_client),
            idG: idG,
            idE: idE,
          });
        })
        .catch((err) =>
          dispatch({
            type: DELETE_FAIL_PARCOURS_CLIENTS,
            error: err,
          })
        );
    });
  };
}
